import {ComponentFactoryResolver, ComponentRef, inject, Injectable, InjectionToken, Type, ViewContainerRef} from "@angular/core";
import {Store, select, createSelector} from "@ngrx/store";
import {map} from "rxjs/operators";
import {PRIMARY_OUTLET, Router, UrlSegment, UrlSegmentGroup, UrlTree} from "@angular/router";
import {Observable} from "rxjs";


import {IAppState} from "../../../store/app-store/state/app.state";
import {IApplicationParametersState} from "../../../store/app-store/state/application-parameters/application-parameters.state";
import {IResourcesState} from "../../../store/app-store/state/resources/resources.state";
import {IAuthenticationState} from "../../../store/app-store/state/security/authentication.state";
import {IAuthenticatedUserState} from "../../../store/app-store/state/security/authenticated-user.state";
import {IMDMState} from "../../../store/app-store/state/mdm/mdm.state";
import {IViewElementsState} from "../../../store/app-store/state/system/system.state";
import {IPartnersState} from "../../../store/app-store/state/partners/partners.state";
import {IConfigurationState} from "../../../store/app-store/state/configuration/configuration.state";
import {ITopPanelState, ITopPanelStoreValue} from "../../../store/app-store/state/top-panel/top-panel.state";



import {GetPartners} from "../../../store/app-store/actions/partners/partners.actions";
import {GetAccounts} from "../../../store/app-store/actions/accounting/accounting.actions";
import {GetAvgPrice, GetAvgPriceFailure, GetBestItems, GetBestItemsFailure, GetKeyIndicators, GetKeyIndicatorsFailure, GetKeyIndicatorsSuppliers, GetKeyIndicatorsSuppliersFailure, GetMarketShare, GetMarketShareFailure, GetProfitability, GetProfitabilityFailure, GetPromo, GetPromoFailure, GetServiceLevel, GetServiceLevelFailure, GetStockRotation, GetStockRotationFailure} from "../../../store/app-store/actions/reports/insights.actions";
import {ClearAppParam, RemoveAppParam, SetAppParam, SetDatasourcePartyId, SetDate, SetFinDepartment, SetNomenclature, SetNomenclatureList, SetOrganisation, SetOrganisationList, SetOsaIncidentKind, SetOsaIncidentSelection, SetOsaIncidentType, SetSupplier} from "../../../store/app-store/actions/application-parameters/application-parameters.actions";
import {Authenticate, AuthenticateByAccessToken, AuthenticateByOidc, AuthenticationFailure, Logout, SetToken} from "../../../store/app-store/actions/security/authentication.actions";
import {GetTasksList, GetTasksListFailure} from "../../../store/app-store/actions/tasks/tasks.actions";
import {SetUserEmail} from "../../../store/app-store/actions/security/authenticated-user.actions";
import {GetScanning, GetScanningFailure} from "../../../store/app-store/actions/osa/osa.actions";
import {InitMDMStore, LoadTypes} from "../../../store/app-store/actions/mdm/mdm.actions";
import {DisplayMode, SetDisplayMode, SetDisplaySize, SetViewMode, ViewMode} from "../../../store/app-store/actions/system/system.actions";
import {ClearParameters, RemoveParameter, SetParameter} from "../../../store/app-store/actions/top-panel/top-panel.actions";


import {IMDMElement, IMDMHierarchy, IMDMLevel, IMDMType} from "@retail-data-factory/rdf-angular-types-api";
import {IAppParamData} from "../../../store/app-store/models/application-parameters/application-parameters.interface";
import {emptyPartner, IPartner} from "../../../store/app-store/models/partners/partners.interface";
import {emptyUser, IUser} from "@retail-data-factory/rdf-angular-types-api";
import {AssistTranslationService} from "@retail-data-factory/rdf-angular-translation-service";
import {ISubscription} from "@retail-data-factory/rdf-angular-types-api";


export type RouteStatus = 'started' | 'canceled' | 'finished';

export interface IRouteState {
  id: number;
  url: string;
  urlAfterRedirects: string;
  status: RouteStatus;
}


@Injectable({
  providedIn: 'root'
})
export class Presenter {
  authentication$ = this._store.select(state => state.authentication);
  authenticationState: IAuthenticationState;

  authenticatedUser$ = this._store.select(state => state.authenticatedUser);
  authenticatedUserState: IAuthenticatedUserState;

  partners$ = this._store.select(state => state.partners);
  partnersState: IPartnersState;

  accounting$ = this._store.select(state => state.accounting);
  accountOperations$ = this._store.select(state => state.accountOperations);

  //Ресурсы
  resources$ = this._store.select(state => state.resources);
  resourcesState: IResourcesState;
  currentResource$ = this._store.select(state => state.currentResource);

  router$ = this._store.select(state => state.router);


  //MDM
  mdm$ = this._store.select(state => state.mdm);
  mdmState: IMDMState;


  configuration$ = this._store.select(state => state.configuration);

  mdm2$;

  //отчеты
  reports$ = this._store.select(state => state.reports);

  //параметры
  parameters$ = this._store.select(state => state.applicationParameters);
  parametersState: IApplicationParametersState;

  displayMode$ = this._store.select(state => state.displayMode);

  viewElementsState$ = this._store.select(state => state.viewElements);


  topPanel$: Observable<ITopPanelState> = this._store.select(state => state.topPanel);

  queryParameters: object;


  marketplace$ = this._store.select(state => state.marketplace);
  marketplaceDatasourceProviders$ = this._store.select(state => state.marketplace.datasourceProviders);

  constructor(
    public _store: Store<IAppState>,
    private resolver: ComponentFactoryResolver,
    private assistTranslationService: AssistTranslationService,
    private router: Router
  ) {
    console.log('Presenter Init');
    const selectMdm = (state: IAppState) => state.mdm;
    const mdmSelector = createSelector(
      selectMdm,
      (state: IMDMState) => state
    );
    //sitesRoutes.unshift({path: 'reports',component: RdfCR2MainPageComponent });

    this.mdm2$ = this._store.pipe(select(mdmSelector));
    this.mdm2$.subscribe(value => {
      console.log('value');
    });

    this.parameters$.subscribe((data) => {
      this.parametersState = data;
    });

    this.resources$.subscribe((data) => {
      this.resourcesState = data;
    });

    this.mdm$.subscribe((data) => {
      this.mdmState = data;
    });

    this.partners$.subscribe((data)=>{
      this.partnersState = data;
    })

    this.authentication$.subscribe((data) => {
      this.authenticationState = data;
    });
    this.authenticatedUser$.subscribe((data) => {
      this.authenticatedUserState = data;
    });


    // this.router.events.subscribe(value => {
    //
    //   if (value instanceof RouteConfigLoadEnd) {
    //     setTimeout(() => {
    //       const abc = value;
    //       const config = this.router.config;
    //       console.log('dddd');
    //
    //     });
    //
    //   }
    //
    //   if (value instanceof NavigationStart) {
    //     this.pushRoute({id: value.id, url: value.url, urlAfterRedirects: '', status: "started"});
    //   }
    //   if (value instanceof NavigationCancel) {
    //     this.pushRoute({id: value.id, url: value.url, urlAfterRedirects: '', status: "canceled"});
    //   }
    //
    //   if (value instanceof NavigationEnd) {
    //     this.pushRoute({id: value.id, url: value.url, urlAfterRedirects: value.urlAfterRedirects, status: "finished"});
    //   }
    //   console.log(value);
    //   if (!this.resourcesState.isLoaded) {
    //     return;
    //   }
    //   const tmp = this.resourcesState;
    //   let newResource = this.resourcesState.data.resources.find(res => value['url'] === `${res.url ? res.url : ''}${res.profile && res.profile['url'] ? res.profile['url'] : ''}` && res.type === 'SCREEN');
    //   if (!newResource) {
    //     //По полной ссылке не нашли. Пытаемся найти первый попавшийся ресурс по url группы
    //     newResource = this.resourcesState.data.resources.find(res => value['url'] === `${res.url ? res.url : ''}` && res.type === 'SCREEN');
    //   }
    //   this.setCurrentResource(newResource);
    // });
    this.checkLocalStorageToken();

  }

  /**
   * Получить текущий токен
   */
  get accessToken(): string {
    return this.getCurrentStateValue(this.authentication$).data.accessToken;
  }

  /**
   * Получить текущий токен WF
   */
  get workflowToken(): string {
    return this.getCurrentStateValue(this.authentication$).data.workflowToken;
  }

  /**
   * Полуить ID текущей пати
   */
  get currentPartyId(): string {
    const authenticatedUser: IAuthenticatedUserState = this.getCurrentStateValue(this.authenticatedUser$);
    if (authenticatedUser && authenticatedUser.isLoaded && authenticatedUser.data) {
      if (authenticatedUser.data.selectedPartyProfile && authenticatedUser.data.selectedPartyProfile['id'] !== null && authenticatedUser.data.selectedPartyProfile['id'] !== undefined && authenticatedUser.data.selectedPartyProfile['id'] !== '') {
        return authenticatedUser.data.selectedPartyProfile['id'];
      } else {
        return authenticatedUser.data.selectedPartyId;
      }
    } else {
      return '';
    }
    //return this.getCurrentStateValue(this.authenticatedUser$).data.selectedPartyProfile.id;
  }

  get currentDatasourcePartyId(): string {
    return this.parametersState.selectedDatasourcePartyId;
  }


  /**
   * Получить логин аунтентифицированного пользователя
   */
  get login(): string {
    const authenticatedUser: IAuthenticatedUserState = this.getCurrentStateValue(this.authenticatedUser$);
    if (authenticatedUser && authenticatedUser.isLoaded && authenticatedUser.data) {
      return authenticatedUser.data.login;
    } else {
      return '';
    }

  }

  get currentUser(): IUser {
    const user: IUser = {
      ...emptyUser,
      id: this.authenticatedUserState.data.id,
      userName: `${this.authenticatedUserState.data.userProfile.firstName} ${this.authenticatedUserState.data.userProfile.lastName}`,
      firstName: this.authenticatedUserState.data.userProfile.firstName,
      lastName: this.authenticatedUserState.data.userProfile.lastName,
      type: this.authenticatedUserState.data.userType,
      login: this.authenticatedUserState.data.login,
      email: this.authenticatedUserState.data.email
    };
    return user;
  }

  //Работа с токеном
  setToken(accessToken: string) {
    this._store.dispatch(new SetToken(accessToken));
  }

  destroyToken() {
  }

  /**
   * Аунтентификация пользователя по паре логин-пароль
   * @param login
   * @param password
   */
  authenticateByLogin(login: string, password: string) {
    this._store.dispatch(new Authenticate({login: login, password: password}));
  }
  authenticateByGoogle(oidcToken: string) {
    this._store.dispatch(new AuthenticateByOidc({oidcToken: oidcToken, oidcProviderType: "google"}));
  }

  /**
   * Logout
   */
  logout() {
    this._store.dispatch(new Logout());
  }


  setUserEmail(email: string) {
    this._store.dispatch(new SetUserEmail(email));

  }

  //Работа со списком ресурсов


  //Работа со списком партнеров
  getPartners() {
    this._store.dispatch(new GetPartners());
  }


  getPartnersList(): Array<IPartner> {
    const partnersState: IPartnersState = this.getCurrentStateValue(this.partners$);
    if (partnersState && partnersState.isLoaded) {
      return Array.from(partnersState.data);
    } else {
      return [];
    }
  }

  getPartnerById(partyId: string): IPartner {
    if (!partyId) return {...emptyPartner};
    const partner: IPartner = this.getPartnersList().find(t => t.partyId === partyId);
    return partner ? partner : {...emptyPartner};
  }

  //Получить список счетов
  getAccounts() {
    this._store.dispatch(new GetAccounts());
  }

  getAccountOperations() {

  }

  clearAccountOperations() {

  }

  getSelectedDataSourcePartner(): IPartner {
    const appParametersState: IApplicationParametersState = this.getCurrentStateValue(this.parameters$);
    const partnersList = this.getPartnersList();
    let selectedPartner = {...emptyPartner};
    partnersList.forEach(t => {
      if (t.partyId === appParametersState.selectedDatasourcePartyId) {
        selectedPartner = t;
      }
    });
    return selectedPartner;
  }

  getReportStockRotation(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetStockRotationFailure());
    } else {
      this._store.dispatch(new GetStockRotation());
    }
  }

  getReportMarketShare(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetMarketShareFailure());
    } else {
      this._store.dispatch(new GetMarketShare());
    }
  }

  getReportKeyIndicators(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetKeyIndicatorsFailure());
    } else {
      this._store.dispatch(new GetKeyIndicators());
    }
  }

  getReportProfitability(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetProfitabilityFailure());
    } else {
      this._store.dispatch(new GetProfitability());
    }
  }

  getReportPromo(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetPromoFailure());
    } else {
      this._store.dispatch(new GetPromo());
    }
  }

  getReportBestItems(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetBestItemsFailure());
    } else {
      this._store.dispatch(new GetBestItems());
    }
  }

  getReportAvgPrice(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetAvgPriceFailure());
    } else {
      this._store.dispatch(new GetAvgPrice());
    }
  }

  getReportKeyIndicatorsSuppliers(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetKeyIndicatorsSuppliersFailure());
    } else {
      this._store.dispatch(new GetKeyIndicatorsSuppliers());
    }
  }

  getReportServiceLevel(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetServiceLevelFailure());
    } else {
      this._store.dispatch(new GetServiceLevel());
    }
  }


  getTasksListReport(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetTasksListFailure());
    } else {
      this._store.dispatch(new GetTasksList());
    }
  }

  //OSA Reporting

  getScanningsReport(clear?: boolean) {
    if (clear === true) {
      this._store.dispatch(new GetScanningFailure());
    } else {
      this._store.dispatch(new GetScanning());
    }

  }


  select(selector) {
    return this._store.pipe(select(selector));
  }


  //MDM
  initMdmStore() {
    this._store.dispatch(new InitMDMStore());
  }

  loadMdmTypes() {
    this._store.dispatch(new LoadTypes());
  }

  getMdmState(): IMDMState {
    return this.getCurrentStateValue(this.mdm$);
  }

  getMdmType(typeCode): IMDMType {
    const mdmState: IMDMState = this.getCurrentStateValue(this.mdm$);
    return mdmState.types.find(t => t.code === typeCode);
  }

  getConfigurationState(): IConfigurationState {
    const configurationState: IConfigurationState = this.getCurrentStateValue(this.configuration$);
    return configurationState;
  }


  //Параметры

  setAppParamNomenclature(param: { code: string, level: string }) {
    this._store.dispatch(new SetNomenclature(param));
  }

  setAppParamNomenclatureList(param: { list: Array<string>, level: string }) {
    this._store.dispatch(new SetNomenclatureList(param));
  }

  setAppParamOrganisation(param: { code: string, level: string }) {
    this._store.dispatch(new SetOrganisation(param));
  }

  setAppParamOrganisationList(param: { list: Array<string>, level: string }) {
    this._store.dispatch(new SetOrganisationList(param));
  }

  setAppParamDate(param: { from: string, to: string; periodType: string }) {
    this._store.dispatch(new SetDate(param));
  }

  setAppParamSupplier(param: string) {
    this._store.dispatch(new SetSupplier(param));
  }

  setAppParamDatasourcePartyId(param: string) {
    console.log('setAppParamDatasourcePartyId');
    this._store.dispatch(new SetDatasourcePartyId(param));
  }

  setAppParamFinDepartment(param: string) {
    this._store.dispatch(new SetFinDepartment(param));
  }

  setAppParamOsaIncidentSelection(param: string) {
    this._store.dispatch(new SetOsaIncidentSelection(param));
  }

  setAppParamOsaIncidentKind(param: string) {
    this._store.dispatch(new SetOsaIncidentKind(param));
  }

  setAppParamOsaIncidentType(param: Array<Array<string>>) {
    this._store.dispatch(new SetOsaIncidentType(param));
  }

  getAppParam(): IApplicationParametersState {
    const result: IApplicationParametersState = this.getCurrentStateValue(this.parameters$);
    return result;

  }


  clearReportParameters() {
    console.log(`[Presenter][clearReportParameters] Очистка всех параметров`);
    this._store.dispatch(new ClearAppParam());
  }

  setReportParameter(param: IAppParamData) {
    console.log(`[Presenter][setReportParameter] Установка параметра '${param.code}'`, param);
    this._store.dispatch(new SetAppParam(param));
  }

  removeReportParameter(param: string) {
    console.log(`[Presenter][setReportParameter] Удаление параметра ${param}`);
    this._store.dispatch(new RemoveAppParam(param));
  }

  getReportParameter(parameterType: string): IAppParamData {
    console.log(`[Presenter][getReportParameter] Получение параметра ${parameterType}`);

    const result: IAppParamData = this.parametersState.selectedReportParam.params.find(item => item.code === parameterType);

    console.log(`[Presenter][getReportParameter] Получение параметра ${parameterType}. Возвращаем значение `, result);
    return result;

  }

  getReportParameters(): IApplicationParametersState {
    console.log(`[Presenter][getReportParameters] Получение всех параметров.`);
    const result = this.getCurrentStateValue(this.parameters$);
    console.log(`[Presenter][getReportParameters] Получение всех параметров. Возвращаем значение `, result);
    return result;
  }

  /**
   * Получить текущее состояние ветки хранилища
   * @param state$
   */
  getCurrentStateValue(state$) {
    let result = null;
    const promise = state$.pipe(
      map(
        (data) => {
          result = data;
          return result;
        }
      )
    ).toPromise();

    return result;
  }


  //MDM
  getMDMDefaultHierarchy(typeCode: string): IMDMHierarchy {
    const result = this.mdmState.hierarchy.find(item => item.isDefault && item.type.code === typeCode);
    return result;
  }
  getMDMLevel(typeCode: string, levelNum: number): IMDMLevel {
    const hier = this.getMDMDefaultHierarchy(typeCode);
    if (hier) {
      return hier.levels && hier.levels.length>levelNum? hier.levels[levelNum]:null;
    }else {
      return null;
    }
  }


  /**
   * Возвращает список элементов MDM указанного типа на указанном уровне иерархии. Есть поддержка фильтрации на основании атрибутной безопасности в подписках
   * @param typeCode - тип справочника
   * @param levelNum - уровень справочника
   * @param resourceCode - код ресурса, по которому произвести ограничение атрибутной безопасности
   */
  getMDMElements(typeCode: string, levelNum: number, resourceCode = ''): Array<IMDMElement> {
    const hier = this.getMDMDefaultHierarchy(typeCode);
    const mdmElements = hier.levels[levelNum].elements;
    if (!hier || !hier.levels || hier.levels.length === 0) {
      return [];
    }

    if (levelNum<0 || levelNum>= hier.levels.length) {
      return [];
    }
    if (!resourceCode) {
      return mdmElements;
    }

    //Получить список подписок в которых есть указанный ресурс
    const subscriptions:Array<ISubscription> = this.getCurrentStateValue(this.marketplace$)?.subscriptions;


    // const tmp = subscriptions.find(t=>t.id === '4702');
    // if (tmp) {
    //   tmp.service.attributeTypes.push({
    //     code: 'RED_STORE',
    //     name: '',
    //     description: '',
    //     levelNum: '4',
    //     profile: null
    //   });
    // }

    //Проверить что сервисы из этих подписок ограничивают данный тип MDM
    //И Получить список ограничений, которые есть в подписках в которых есть этот ресурс
    let founded = false;
    const filteredElements: Array<IMDMElement> = [];
    subscriptions
      .forEach(subscription=>{
      if (
        subscription.status === 'ACTIVE' &&
        subscription.service.resources.find(k=>k.code === resourceCode) &&
        subscription.service.attributeTypes.find(k=>k.code === typeCode)) {
        founded = true;
        subscription.data.forEach(subscriptionData=>{
          if (subscriptionData.code === typeCode) {
            subscriptionData.values.forEach(e=>{
              const elementArray = hier.levels[levelNum].elements.filter(elem=>elem.rawData[`level_${subscriptionData.level}_code`]===e.code);
              elementArray.forEach(element=>{
                if (!filteredElements.find(f=>element.code === f.code)) {
                  filteredElements.push(element);
                }

              });
            });
          }
        });
      }
    });

    //Если хоть один из этих сервисов не ограничивает данный ресурс, значит возвращаем все данные
    if (!founded) {
      return mdmElements;
    }


    //Если список ограничений пуст, то возвращаем пустой массив
    if (filteredElements.length === 0) {
      return [];
    }


    //Возвращаем ограниченный mdmElements
    let result: Array<IMDMElement> = [];
    result = mdmElements.filter(t => !!filteredElements.find(k=>k.code === t.code));

    return result;
  }

  //System
  setDisplayMode(mode: DisplayMode) {
    this._store.dispatch(new SetDisplayMode(mode));
  }

  getDisplayMode(): DisplayMode {
    return this.getCurrentStateValue(this.displayMode$);
  }

  setViewMode(mode: ViewMode) {
    const url = this.getCurrentUrl();
    if (mode === 'normal' && (url === "/main" || url === "/" || url === "/login")) {
      switch (url) {
        case '/':
          mode = 'initial';
          break;
        case '/login':
          mode = 'login';
          break;
        case '/main':
          mode = 'main';
          break;
      }
    }
    this._store.dispatch(new SetViewMode(mode));
  }

  getViewMode(): ViewMode {
    return this.getCurrentStateValue(this.viewElementsState$).viewMode;
  }

  getViewElementsState(): IViewElementsState {
    const result = this.getCurrentStateValue(this.viewElementsState$);
    return result;
  }

  /**
   * Получить текущий URL
   */
  getCurrentUrl(): string {
    const state = this.getCurrentStateValue(this.router$);
    if (state && state.state) {
      const url = state.state.url;
      return url;
    } else {
      return '';
    }

  }

  /**
   * Получить URL текущего приложения, то есть первый сегмент всего URL
   */
  getCurrentApplicationUrl(): string {
    const tree: UrlTree = this.router.parseUrl(this.getCurrentUrl());
    const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
    const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'

    return s.length ? s[0].path : '';

  }


  checkLocalStorageToken() {
    const token = window.localStorage.getItem('access_token');
    const workflowToken = window.localStorage.getItem('workflow_token') ? window.localStorage.getItem('workflow_token') : '';

    if (token) {
      this._store.dispatch(new AuthenticateByAccessToken({accessToken: token, workflowToken: workflowToken}));
      //this._store.dispatch(new Authenticate({login:'froneri_demo', password:'Test1234'}));
    } else {
    //Это сделано для того, что если нет токена, приложение проваливалось на логин
      this._store.dispatch(new AuthenticationFailure());
//      this.router.navigate(['login']).catch(e=>console.error(e));
    }
  }


  setDisplaySize(size: { width: number, height: number }) {
    this._store.dispatch(new SetDisplaySize(size));
  }


  setStoredValue(componentName: string, value: object) {
    console.log(`[Presenter][getStoredValue] Сохранение значений для компонента с именем '${componentName}'`, value);

    if (!value) {
      this.removeStoredValue(componentName);
      return;
    }
    console.log(`[Presenter][getStoredValue] Сохраненяем значение для компонента с именем '${componentName}'`, value);
    this._store.dispatch(new SetParameter({name: componentName, value: value}));
    /*    const storedValue:ITopPanelStoreValue = this.parametersValues.find(t=>t.name === componentName);
        if (storedValue) {
          storedValue.value = value;
        }else {
          this.parametersValues.push({name: componentName, value: value});
        }

     */
  }

  removeStoredValue(componentName: string) {
    this._store.dispatch(new RemoveParameter(componentName));
    //this.parametersValues = this.parametersValues.filter(t=>t.name!==componentName);
  }

  getStoredValue(componentName: string): object {
    console.log(`[Presenter][getStoredValue] Восстановление значений для компонента с именем '${componentName}'`);

    const topPanelState: ITopPanelState = this.getCurrentStateValue(this.topPanel$);

    if (topPanelState) {
      const value: ITopPanelStoreValue = topPanelState.parametersValues.find(t => t.name === componentName);
      if (value) {
        console.log(`[Presenter][getStoredValue] Восстановлено значение для компонента с именем '${componentName}'`, value);
        return value.value;
      } else {
        console.log(`[Presenter][getStoredValue] Значение для компонента с именем '${componentName}' не найдено`);
        return undefined;
      }

    }
    return null;
    /*


    const storedValue:ITopPanelStoreValue = this.parametersValues.find(t=>t.name === componentName);
    if (storedValue) {
      return storedValue.value;
    }else {
      return undefined;
    }

     */
  }

  clearStoredValues() {
    console.log(`[Presenter][clearStoredValues] Очистака сохраненных параметров компонентов`);
    this._store.dispatch(new ClearParameters());
  }


  setQueryParameters(queryParam: object) {
    this.queryParameters = queryParam;
    //this._store.dispatch(new SetQueryParameters(queryParam));
  }

  getQueryParameters(): object {
    return this.queryParameters;
    const topPanelState: ITopPanelState = this.getCurrentStateValue(this.topPanel$);
    return topPanelState ? topPanelState.queryParameters : undefined;
  }

  /**
   * Cоздание компонента по его классу и размещение его в контейнере
   * Данный метод не будет работать в продуктиве, поскольку настройки минификациии TenserPlugin также минифицируют имена классов,
   * и соответсвенно нет возиможности найти фабрику по имени класса
   * @param className - имя класса компонента
   * @param container - контейнер, в котором будет размещен создаваемый компонент
   */
  createComponentByClassName(className: string, container: ViewContainerRef): ComponentRef<any> {

    if (!this.resolver['_factories']) return null;

    const factories = Array.from(this.resolver['_factories'].keys());
    const factoryClass = factories.find((x: any) => x.name === className) as Type<any>;
    if (factoryClass) {
      const factory = this.resolver.resolveComponentFactory(factoryClass);
//    this.componentRef = this.vcRef.createComponent(factory);
      const componentRef: ComponentRef<any> = container.createComponent(factory);

      //this.onComponentCreate.emit(this.componentRef);
//    componentRef.instance['onDataChanged'].subscribe((event)=>this.onFormDataChanged(event));
//    componentRef.instance['task'] = this.task;
//    componentRef.instance['isReadOnly'] = this.isTaskReadOnly();

      /*    for (const parameter in this.component.componentParameters)  {
            if (parameter in this.componentRef.instance) {
              if (this.componentRef.instance[parameter] instanceof EventEmitter) {
                const fn = new Function('event', this.component.componentParameters[parameter]);
                this.componentRef.instance[parameter].subscribe(event=>fn(event));
              } else {
                this.componentRef.instance[parameter] = this.component.componentParameters[parameter];
              }
            }

       */
      return componentRef;
    } else return null;
  }

  /**
   * Cоздание компонента по его селектору и размещение его в контейнере
   * @param selectorName - имя селектора создаваемого компонента
   * @param container - контейнер, в котором будет размещен создаваемый компонент
   */
  createComponentBySelector(selectorName: string, container: ViewContainerRef): ComponentRef<any> {
    if (!this.resolver['_factories']) return null;
    const factories = Array.from(this.resolver['_factories'].keys());
    const factoryClass = factories.find((x: any) => {
      if (x['__annotations__'] && Array.isArray(x['__annotations__']) && x['__annotations__'].length) {
        const a = selectorName;
        const b = x['__annotations__'][0]['selector'];
        return a === b;
      } else {
        return false;
      }
    }) as Type<any>;
    if (factoryClass) {
      const factory = this.resolver.resolveComponentFactory(factoryClass);
      const componentRef: ComponentRef<any> = container.createComponent(factory);
      return componentRef;
    } else {
      return null;
    }
  }

  /**
   * Есть ли у текущей пати свои данные?
   */
  hasOwnData(): boolean {
    //Тупая логика - считаем что если у пати есть к кому пойти за данными, то своих данных нет. Потом это нужно поменять на признак у пати
    const providers = this.getCurrentStateValue(this.marketplaceDatasourceProviders$);
    if (providers && providers.length && providers.find(t => t.id !== '0')) {
      return false;
    } else {
      return true;
    }


  }


  get isPartyAreSubdivisionOfAdminParty(): boolean {
    const adminParty = this.getPartnersList().find(t => t.partyId === '0' && t.childRelationship && t.childRelationship.profile && t.childRelationship.profile['type'] === 'subdivision');
    return !!adminParty;

  }

}
